import TextInput from "components/form/input/TextInput";
import { GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields";
import IndicadorEntity from "..";

export function ParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={IndicadorEntity.field + tipoIndicadorField}
            bottomFields={
                <>

                    <ParamFormRow label="Metros por Ponto">
                        <TextInput name="manual.metrosPorPonto" label="Valor (Metros)"  type="number" />
                    </ParamFormRow>

                    <ParamFormRow label="Meta">
                        <TextInput name="manual.meta" label="Meta (%)" />
                    </ParamFormRow>
                </>
            }

        />
    );
}
